import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router'
import { Button } from 'antd-mobile'

export const Route = createFileRoute('/test/sign/$id')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()
  const { id } = useParams({ from: '/test/sign/$id' })
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <Button
        onClick={() => {
          navigate({
            to: '/order/$orderId',
            params: { orderId: id },
            replace: true,
          })
        }}
        color="primary"
        size="large"
      >
        完成签署
      </Button>
    </div>
  )
}
